/**
 * Exports article image-related design tokens
 */

// Allowed image column 'widths' 
export const allowedWidths = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ];

